<template>
  <div>

    <ul class="ad-list">
      <li class="ad-item" v-for="(item, index) in adData" :key="index">
        <a class="activeItem"> 
          <!--@click="showImg(item.imageUrl)"-->
          <div class="ad-image" @click="showImg(item.imageUrl)">
            <van-image fit="cover" lazy-load class="ad-image" :src="item.imageUrl" :alt="item.title" />
          </div>
          <van-button type="danger" class="ad-buy"  text="立即购买" @click="showImg(item.imageUrl)" />
          <van-overlay :show="showModal" @click="hideImg">
            <div class="wrapper">
              <van-image fit="cover" :src="imgUrl" />
            </div>
          </van-overlay>


          <!-- <div class="ad-info">
            <div class="ad-title" v-if="fromIndex">{{ item.title}}</div>
            <div class="ad-buy">
              <van-button size="large" type="info" style="height:30px;">立即购买</van-button>
            </div>
          </div> -->
        </a>
      </li>
    </ul>

  </div>
  
</template>

<script>
 import { Toast, Image as VanImage, Button as VanButton } from "vant";

  export default {
    name: "FunctionBar",
    props: {
      adData: Array
    },
    components: {
      VanImage,
      VanButton
    },
    data() {
      return {
        title: "sssss",
        showModal: false,
        imgUrl: ''
      };
    },
    computed: {
    },
    mounted() {
    },
    methods: {
      showImg(url) {
        this.showModal = true;
        this.imgUrl = url;
      },
      hideImg() {
        this.showModal = false;
        console.log(this.showModal);
      },
    },
  };
</script>
<style lang="less" scope>
  .ad-list{
    overflow:hidden;
    _zoom:1;
  }
  .ad-item{
    float:left;
    width:31%;
    margin: 1% 0 0 1%;
    position: relative;
  }
  .ad-image{
    width:100%;
    height:110px;
    overflow:hidden;
  }
  
  .ad-info{
    margin-top:5px;
  }
  .ad-buy{
    position: absolute;
    bottom:0;
    left:0;
    width:100%;
    height: 35px;
    line-height: 35px;
    font-size: 14px;

    color:#fff;
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
</style>
